import React from 'react'
import FaqSection from '../../sections/Home/FaqSection/FaqSection'

const FaqPage = () => {
  return (
    <div className='flex justify-center w-full pt-10'>
      <FaqSection />
    </div>
  )
}

export default FaqPage
